import { isBrowser } from '@/utils/runtime'

/* --------------------------------------------------
   Ensures `window.gtag` + `dataLayer` exist.
   Returns `true` in every browser-side scenario.
--------------------------------------------------- */
function ensureStub() {
  if (!isBrowser) return false

  if (typeof window.gtag !== 'function') {
    window.dataLayer = window.dataLayer || []
    window.gtag = (...args) => window.dataLayer.push(args)
  }
  return true
}

/* ---------- Public helpers (mirrors GA API) ---------- */

export const track = (name, params = {}) => {
  if (ensureStub()) window.gtag('event', name, params)
}

export const setUser = (id, mobile) => {
  if (!ensureStub()) return
  window.gtag('set', { user_id: id || null })

  if (mobile) {
    window.gtag('set', 'user_properties', { mobile_number: String(mobile) })
  }
}

export const clearUser = () => {
  if (ensureStub()) {
    window.gtag('set', { user_id: null })
    window.gtag('set', 'user_properties', null)
  }
}
